import React from 'react';
import ManageBuyerForm from '../Forms/manage_buyer_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
    { label: 'Address', field: 'Address' },
    { label: 'Contact No.', field: 'ContactNo' },
];

function Manage_buyer() {
    return (
        <ManageDataPage
            title="Manage Buyer"
            endpoint="get_manage_buyer_table"
            columns={COLUMNS}
            idKey="BuyerID"
            FormComponent={ManageBuyerForm}
            searchPlaceholder="Search name, address, contact..."
        />
    );
}

export default Manage_buyer;
